import { render, staticRenderFns } from "./ResidentContactsWidget.vue?vue&type=template&id=11351860&scoped=true&"
import script from "./ResidentContactsWidget.vue?vue&type=script&lang=ts&"
export * from "./ResidentContactsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentContactsWidget.vue?vue&type=style&index=0&id=11351860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11351860",
  null
  
)

export default component.exports